import React from "react";
import type { GridItemProps } from "react-virtuoso";
import { useLGridistVirtualizedContext } from "./context";
import { GridVirtualizedBoxes, classes } from "./styles";

export const VirtuosoItem = React.forwardRef(function VirtuosoItem({ ...props }: GridItemProps, ref) {
  const { ListItem } = useLGridistVirtualizedContext();

  return <GridVirtualizedBoxes {...props} {...ListItem} ref={ref} className={classes.items}></GridVirtualizedBoxes>;
});
